import { render } from "./HistoryDialog.vue?vue&type=template&id=594cda46"
import script from "./HistoryDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryDialog.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/exhishare/HistoryDialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "594cda46"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('594cda46', __exports__)) {
    api.reload('594cda46', __exports__)
  }
  
  module.hot.accept("./HistoryDialog.vue?vue&type=template&id=594cda46", () => {
    api.rerender('594cda46', render)
  })

}


export default __exports__